// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_LEy","controls":"styles_controls__1ne1m","charLimit":"styles_charLimit__2cXLX","input":"styles_input__1Yh9P","send":"styles_send__2ro_2"};